import React, { useState, useEffect } from 'react';
import { ListGroup, Col, Row } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {LBL_DESCRIPTION,LBL_SELECT_All} from '../../../configs/labelConfigs';

var currentEl = null;
const CustomMultiSelect = ({
    data,
    onChange,
    isTextBox,
    classValue,
    marginTop0,
    isBoxTwo,
    isBorderColor,
    btnTextClass,
    isDisable,
    trimString,
    isFloat,
    initialText,
    isInputDescr,
    needSelectAll,
    selectAllText,
    disableSelectAll,
    id,
    listClassName,
    columnLength,
    selTextNumber,
}) => {
    const [open, setOpen] = useState(false);
    const [localData, setLocalData] = useState([]);
    const [selectAllSelected, setSelectAllSelected] = useState(false);

    useEffect(() => {
        if(data && Array.isArray(data) && data.length) {
            const localInitData =  data.map(item => ({
                label : item.label,
                value : item.value,
                info : item.info,
                selected : !!(item.inputVal),
                inputVal : Number(item.inputVal) || 0,
                inputValTwo : Number(item.inputValTwo) || 0,
                inputValDescr : item.inputValDescr,
                checkDisable : item.checkDisable?item.checkDisable:false
            }));
            setLocalData(localInitData);
        }else{
            setLocalData([]);
        }
    }, [data,disableSelectAll]);

    const onToggle = (e) => {
        setOpen(!open);
        if(!open){
           currentEl = e.target;
           checkAllSelected(); 
        }else{
           currentEl = null; 
        }
    }

    window.onmousedown = function (e) {
        var el = e.target;
        var level=0;
        var c = el;
        while(c.classList !==undefined && !c.classList.contains("multisel_textbox")&&level!==7){
            c = c.parentNode;
            level++;
        }
        if(currentEl !== null && c.classList !==undefined && (!c.classList.contains("multisel_textbox") 
            ||( c.classList.contains("multisel_textbox") && [2,4].indexOf(level) !== -1)) && currentEl!==el){
            currentEl.click();
        } 
    }

    const setOpenValue = (val) => {
        setOpen(val);
    }

    const callParentOnChange = (data) => {
        const dataToReturn = [];
        data.forEach(item => {
            if(item.selected) dataToReturn.push({
                label : item.label,
                value : item.value,
                inputVal : Number(item.inputVal),
                inputValTwo: Number(item.inputValTwo),
                inputValDescr: item.inputValDescr,
                info: item.info,
                checkDisable : item.checkDisable?item.checkDisable:false
            })
        });
        onChange(dataToReturn);
    }

    const onItemCheckChanged = (index) => {
        const newDataToSet = [...localData];
        newDataToSet[index].selected = !localData[index].selected;
        if(localData[index].selected) {
            const currentInputData = data.find(item => item.value === localData[index].value) || {};
            newDataToSet[index].inputVal = currentInputData && currentInputData.inputVal ? currentInputData.inputVal : 0;
            newDataToSet[index].inputValTwo = currentInputData && currentInputData.inputValTwo ? currentInputData.inputValTwo : 0;
            newDataToSet[index].inputValDescr = currentInputData && currentInputData.inputValDescr ? currentInputData.inputValDescr : '';
        }
        else {
            setSelectAllSelected(false);  
        }
        setLocalData(newDataToSet);
        callParentOnChange(newDataToSet);
        checkAllSelected(); 
    }

    const checkAllSelected = () => {
        let allSelected = ''; 
        if(localData.length) {
            allSelected = true; 
            localData.forEach(item => {
                if(!item.selected) {
                    allSelected = false;
                }
            });
        }
        setSelectAllSelected(allSelected); 
    } 

    const onSelectAllChanged = () => {
        if(localData.length) {
            const localInitData =  localData.map(item => ({...item, selected:!selectAllSelected}));
            setLocalData(localInitData);
            callParentOnChange(localInitData);
        }
        setSelectAllSelected(!selectAllSelected); 
    }

    const onInputValChanged = (e,val, index) => {
        const newDataToSet = [...localData];
        if(isFloat){
            if(e.target.validity.valid){
                newDataToSet[index].inputVal = val;
            }else{
                newDataToSet[index].inputVal = newDataToSet[index].inputVal
            }
        }else{
            newDataToSet[index].inputVal = parseInt(val);
        }
        
        setLocalData(newDataToSet);
        callParentOnChange(newDataToSet);
    }

    const onInputValTwoChanged = (val, index) => {
        const newDataToSet = [...localData];
        newDataToSet[index].inputValTwo = Number(val);
        setLocalData(newDataToSet);
        callParentOnChange(newDataToSet);
    }

    const onInputDescrChanged = (val, index) => {
        const newDataToSet = [...localData];
        newDataToSet[index].inputValDescr = val;
        setLocalData(newDataToSet);
        callParentOnChange(newDataToSet);
    }

    const disableSpace = (e)=>{
        if(e.which===32){
            e.preventDefault();
        }
    }

    const dataSelected = [];
    localData.forEach((item) => {
        //if(item.selected) dataSelected.push(`${item.label} ${item.inputVal ? `(${item.inputVal})` : ''}`);
        //if(item.selected) dataSelected.push(`${item.label} ${item.inputVal ? `(${item.inputVal})` : `(0)`}`);
        if(item.selected) dataSelected.push((`${item.label} ${(isTextBox && item.inputVal && !isNaN(item.inputVal)) ? `(${Number(item.inputVal)})` : (isTextBox ? '(0)' : '')}`).trim()); 
    });

    let dataString = '';
    let selNum = (selTextNumber && selTextNumber > 0) ? selTextNumber : 3; 

    if(dataSelected.length>=selNum){
        dataString = dataSelected.slice(0, 1).join(', ')+' + '+(dataSelected.length-1)+' selected';
    }else{
        dataString = dataSelected.join(', ')
    }

    let btnClass = (btnTextClass && btnTextClass.length > 0) ? btnTextClass : ''; 
    let floatingPoint = false;
    if(isFloat !== undefined && isFloat=== true){
        floatingPoint = true;
    }
    let noneSelected = 'None Selected';
    if(initialText !== undefined){
        noneSelected = initialText;
    }
    return (
    <>
        
        <div tabIndex="100000" className={classValue+" form-group skills multiselect"} onClick={isDisable?'':onToggle} >
        <div className="btn-group">
                <button type="button" className={marginTop0+" multiselect dropdown-toggle btn btn-default no-border "+btnClass} >
                    {dataSelected.length ? (trimString==='yes' && dataString.length > 40 ? dataString.substring(0, 40)+'...': dataString) : noneSelected}
                    </button>
            </div>
        </div> 
        {open && <ListGroup id={id?id:'listG'} className={listClassName ? listClassName : ""}>
            {/* <div className='div-scroll-y'></div> */}
            {/* ****************** SELECT ALL OPTION - START ****************** */}
            { needSelectAll && localData && localData.length > 1 && ( 
                <ListGroup.Item key={'selectAll'} >
                    <Row >
                        <Col className="custom-checkbox-mul" md={12}>                                
                            <label className="label-checkbox row" htmlFor={'selectAll'} >
                                <input
                                    type="checkbox"
                                    id={'selectAll'}
                                    checked={selectAllSelected}
                                    onChange={() => onSelectAllChanged()}
                                    disabled={disableSelectAll?disableSelectAll:false}
                                />
                                <span className="label-check">{selectAllText && selectAllText.length ? selectAllText : LBL_SELECT_All}</span>
                            </label>
                        </Col>
                    </Row>
                </ListGroup.Item>)
            }
            {/* ****************** SELECT ALL OPTION - END ******************** */}

            {
                localData.map((item, index) => (
                    <ListGroup.Item key={index} >
                        <Row >
                            <Col className="custom-checkbox-mul" md={columnLength && columnLength > 0 ? columnLength : (isInputDescr ? 5 : 7) }>                                
                                <label className="label-checkbox row float-left" htmlFor={item.label} >
                                    <input
                                        type="checkbox"
                                        id={item.label}
                                        checked={item.selected}
                                        onChange={() => onItemCheckChanged(index)}
                                        disabled={item.checkDisable?item.checkDisable:false}
                                    />
                                    <span className="label-check">{item.label}</span>
                                </label>
                                {item.info && item.info!==item.label && item.info.length > 0 &&
                                    <OverlayTrigger
                                        placement="right"
                                        delay={{ show: 250, hide: 400 }}
                                        overlay={<Tooltip id="filterIcon-tooltip" style={{
                                            opacity: 0.4,
                                          }}>
                                        {item.info}
                                      </Tooltip>}
                                    >
                                    <i className="las la-info-circle margin-left3"></i>
                                    </OverlayTrigger>
                                }
                            </Col>
                            {item.selected && isTextBox && !floatingPoint
                                ? ( <Col>
                                    <input type="text" value={parseInt(item.inputVal)>=0?item.inputVal:''} onChange={(e) => onInputValChanged(e,e.target.value, index)} disabled={item.checkDisable} onKeyPress={(e) =>disableSpace(e)} maxLength="3" className={isBorderColor?'crew-count-border':''}/>
                                </Col> )
                                : item.selected && isTextBox && floatingPoint ?
                                ( <Col>
                                    <input type="text" pattern="[-+]?[0-9]*\.?[0-9]*" value={parseFloat(item.inputVal)>=0?item.inputVal:''} onChange={(e) => onInputValChanged(e,e.target.value, index)} disabled={item.checkDisable} onKeyPress={(e) =>disableSpace(e)} maxLength="" className={isBorderColor?'crew-count-border':''}/>
                                </Col> ):
                                <Col/>
                            }
                            {item.selected && isBoxTwo
                                ? ( <Col className={isBorderColor?'crew-count-border':''}>
                                    <input type="text" value={item.inputValTwo>=0 && item.inputValTwo<=Number(item.inputVal)?item.inputValTwo:''} onChange={(e) => onInputValTwoChanged(e.target.value, index)} disabled={item.checkDisable} className={item.inputValTwo>Number(item.inputVal)?'input-error':'input-two'} onKeyPress={(e) =>disableSpace(e)} maxLength="3" />
                                </Col> )
                                : ''
                            } 
                            {item.selected && isInputDescr
                                ? ( <Col md={4} className={isBorderColor?'crew-count-border ':''}>
                                    <input type="text" value={item.inputValDescr} onChange={(e) => onInputDescrChanged(e.target.value, index)} disabled={item.checkDisable} className={'input-two '} placeholder={LBL_DESCRIPTION} />
                                </Col> )
                                : ''
                            }
                        </Row>
                    </ListGroup.Item>
                ))
            }
            
        </ListGroup>} 
    </>
    )
};

export default CustomMultiSelect;